export default {
	getToken: (state) => state.token,
	getTokenExpiration: (state) => state.tokenExpiration,
};
